

















import { defineComponent } from '@vue/composition-api'
import ProductsFromCatalogStore from '@/store/productsList/productsFromCatalog'
import ProductByRowList from '@/views/catalog/ProductByRowList.vue'
import SortProductsList from '@/views/catalog/manageList/SortProductsList.vue'
import QueryInput from '@/views/catalog/manageList/QueryInput.vue'
import ProductListManage from '@/views/catalog/ProductListManage.vue'

export interface MainProduct {
  id: string,
  title: string,
  available: boolean,
  price: number,
  imageUrl: string,
  productUrl: string,
  categories: string[]
}

export default defineComponent({
  name: 'CatalogProductsList',
  components: {
    ProductListManage, QueryInput, SortProductsList, ProductByRowList,
  },
  data() {
    return {
      catalogId: 'not-set',
      sort: {
        field: 'id',
        order: 'asc',
      },
      query: '',
    }
  },
  computed: {

  },
  watch: {
    productsListWatch() {
      return ProductsFromCatalogStore.state.productsList
    },
  },

  methods: {
    hasProductsToDisplay() {
      return ProductsFromCatalogStore.state.productsList !== null
    },
    productsToDisplay() {
      return ProductsFromCatalogStore.state.productsList as Array<MainProduct>
    },
  },
})

